/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportingCategoriesResult } from '../../models/reporting-categories-result';

export interface XenialReportingCategoriesGet$Params {
  'Active-Tenant-Identifier': string;
  'X-Company-Id': string;
  refreshCache?: boolean;
}

export function xenialReportingCategoriesGet(http: HttpClient, rootUrl: string, params: XenialReportingCategoriesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportingCategoriesResult>> {
  const rb = new RequestBuilder(rootUrl, xenialReportingCategoriesGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.header('X-Company-Id', params['X-Company-Id'], {});
    rb.query('refreshCache', params.refreshCache, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportingCategoriesResult>;
    })
  );
}

xenialReportingCategoriesGet.PATH = '/xenial/reporting-categories';
